import { create } from 'zustand';

export const useAuthStore = create((set) => ({
  user: null,
  tenantId: null,
  tenantName: null,
  plan: null,
  role: null,

  setUser: (cognitoUser) => {
    const attrs = cognitoUser?.signInUserSession?.idToken?.payload
      || cognitoUser?.attributes
      || {};
    set({
      user: cognitoUser,
      tenantId: attrs['custom:tenantId'] || null,
      tenantName: attrs['custom:tenantName'] || null,
      plan: attrs['custom:plan'] || null,
      role: attrs['custom:role'] || null,
    });
  },

  setTenantMeta: (name, plan) => set({ tenantName: name, plan }),

  clear: () => set({ user: null, tenantId: null, tenantName: null, plan: null, role: null }),
}));
